import { getRequestConfig } from 'next-intl/server';

// import { appsignal, errorTypes, tags } from '@/crash_reporter/request';
import { routing } from './routing';

const intlErrorDeduplicateStore = {};

export const getMessageFallback = ({ namespace, key, error }) => {
  const path = [namespace, key].filter((part) => part != null).join('.');
  // if (path.includes('.') && !intlErrorDeduplicateStore[error.code + path]) {
  //   intlErrorDeduplicateStore[error.code + path] = true;
  //   const span = appsignal.createSpan();
  //   span
  //     .setError(new Error(errorTypes.i18n))
  //     .setTags(tags)
  //     .setParams({ path, error: error.code });
  //   appsignal.send(span);
  // }
  return path;
};

export default getRequestConfig(async ({requestLocale}) => {
  // This typically corresponds to the `[locale]` segment
  let locale = await requestLocale;

  // Ensure that a valid locale is used
  if (!locale || !routing.locales.includes(locale)) {
    locale = routing.defaultLocale;
  }

  return {
    locale,
    messages: (await import(`./${locale}/index.js`)).messages,
    onError: () => {},
    getMessageFallback,
  };
});
